import React from 'react'
import {withRouter} from 'react-router-dom'
import Websocket from "react-websocket"
import {Col, TabContent, TabPane} from 'reactstrap'
import Loader from 'react-loader-spinner'

import {AppError, Command, Controller} from '../../../models'
import {getController, getStatusLogForController, getTeam, getTeamDiscount, sendCommand, WS_URL} from "../../../api"
import {ui} from '../../'
import {pageHelpers} from '../'
import {subscriptionHelpers} from '../../../dataHelpers'
import {
    SUCCESS, SUBS_PLAN_RENEW_SUCCESS, SUBS_PLAN_EXPIRE, FREE_SUBS_PLAN_EXPIRE_SUPPORT, ASSIGN_PLAN_CONTROLLER,
    FREE_SUBS_PLAN_EXPIRE_CUSTOMER
} from '../../../constants'

import '../../../stylesheets/ControllerDashboard.css'

class ControllerDashboard extends React.Component {
    handleTimeInputChange = (name) => (val) => {
        this.handleCommandFormInputChange({target: {value: val, name: name, checked: false, type: 'time'}})
    }
    removeCommandFromWaiting = (command) => (data) => {
        let waitingOnCommands = this.state.waitingOnCommands.filter((c) => c.id !== command.id)
        this.setState({waitingOnCommands})
    }

    constructor(props) {
        super(props)
        pageHelpers.setupPropsForPage(props, this)

        let {user, token, activeTab} = props
        if (!activeTab || !activeTab.length) {
            activeTab = this.queryParams.tab || '1'
        }

        this.state = {
            controller: null,
            teamName: '',
            fields: [],
            loading: false,
            loadingLog: false,
            requestDataLoading: false,
            sendCommandLoading: false,
            commandPanelVisible: false,
            requestButtonText: "Request New Data",
            sendCommandButtonText: "Send Command",
            waitingOnCommands: [],
            errors: [],
            rate: null,
            units: null,
            toggleRunning: false,
            batchEnable: null,
            setpoint: null,
            resetBatchTotal: null,
            scheduledStart: null,
            repeatStart: null,
            startTime: null,
            scheduledStop: null,
            repeatStop: null,
            stopTime: null,
            resetControllerTotal: null,
            resetWaterTotal: null,
	        discountAmount: 0,
            activeTab,
            user,
            token,
            gerald: new Date(),
            controllerID: this.urlParams.controller_id,
            mobileLogLinkVisible: false,
            /* Subscription Data */
            is_subscription_expired: false,
            is_subscription_trial: false,
            is_subscription_paid: false,
            no_subscription: false,
            subscriptionPlanPrice: 0,
            defaultPlanPrice: 0,
            renewSubsBySupport: false,
            choosePaymentModal: false,
            modal: false,
            subsRemainingDays: 0,
            endsubscription:1964,
            isSeasoned:false,
            modem_model : ''
        }

        this.fetchController = this.fetchController.bind(this)
        this.fetchFields = this.fetchFields.bind(this)
        this.handleControllerWebSocketResponse = this.handleControllerWebSocketResponse.bind(this)
        this.handleCommandWebSocketResponse = this.handleCommandWebSocketResponse.bind(this)
        this.handleRefreshButtonClick = this.handleRefreshButtonClick.bind(this)
        this.handleChangeSettingsButtonClick = this.handleChangeSettingsButtonClick.bind(this)
        this.handleSendCommandButtonClick = this.handleSendCommandButtonClick.bind(this)
        this.handleCommandFormInputChange = this.handleCommandFormInputChange.bind(this)
        this.removeCommandFromWaiting = this.removeCommandFromWaiting.bind(this)
        this.handleTimeInputChange = this.handleTimeInputChange.bind(this)
        this.downloadLogFile = this.downloadLogFile.bind(this)
        this.switchTab = this.switchTab.bind(this)

        this.getSubscriptionPrice = this.getSubscriptionPrice.bind(this)
        this.getSubscriptionData = this.getSubscriptionData.bind(this)
        this.handleRenewSubscriptionClick = this.handleRenewSubscriptionClick.bind(this)
        this.toggle = this.toggle.bind(this)
        this.selectPayment = this.selectPayment.bind(this)
    }

    async componentDidMount() {
        let {user, controllerID, token} = this.state
        if (user && !user.canViewControllers && !user.isSupport) {
            this.history.push('/unauthorized')
        }
        if (controllerID && token) {
            await this.setState({loading: true})
            await this.fetchController()
            await this.fetchFields()
            await this.setState({loading: false})
        }
    }

    async componentWillReceiveProps(nextProps) {
        pageHelpers.setupPropsForPage(nextProps, this)
        let {user, token} = nextProps
        let controllerID = this.urlParams.controller_id
        let activeTab = nextProps.activeTab
        if (!activeTab || !activeTab.length) {
            activeTab = this.queryParams.tab || '1'
        }

        if (activeTab !== this.state.activeTab && controllerID === this.state.controllerID) {
            await this.setState({user, token, activeTab})
            await this.fetchController()
            await this.fetchFields()
        } else if (controllerID && token) {
            await this.setState({user, token, controllerID, activeTab, loading: true})
            await this.fetchController()
            await this.fetchFields()
            await this.setState({loading: false})
        } else {
            await this.setState({user, token, controllerID, activeTab})
        }
    }

    async switchTab(tab) {
        let {activeTab, controllerID} = this.state
        if (activeTab !== tab) {
            this.history.push({
                pathname: `/controllers/${controllerID}`,
                search: `?tab=${tab}`
            })
        }
    }

    async fetchFields() {
        try {
            let {controller, token} = this.state
            let teamId
            if (controller && controller.team) {
                teamId = controller.team
            }

            if (teamId) {
                let team = await getTeam(token, teamId)
                let fields = team.fields
                this.setState({fields})
            }
        } catch (error) {
            console.log(error)
            let appError = new AppError("Failed to get fields", "There was an issue getting information about your fields.")
            this.setState({errors: [appError]})
        }
    }

    async fetchController() {
        let {controllerID, token, user} = this.state
        try {
            let controller = await getController(token, controllerID)
            let teamName = this.state.teamName
            if (controller.team) {
                let team = await getTeam(token, controller.team, 'pico')
                teamName = team.name
            }
            if(controller.latestExtendedDataPoint){
                this.setState({modem_model:controller.latestExtendedDataPoint.modem_model})
            }
            if (!controller.archived) {
		let teamID = user.activeTeam
                await this.getSubscriptionData(token, teamID, controller.id)
                await this.setState({controller, teamName})
	    }
        } catch (error) {
            console.log(error)
            let appError = new AppError("Failed to get controller", "There was an issue getting information about this controller.")
            this.setState({errors: [appError]})
        }
    }

    async handleControllerWebSocketResponse(data) {
        let {token} = this.state
        let controller = Controller.fromAPIObject(JSON.parse(data))
        let teamName = this.state.teamName
        if (controller.team) {
            let team = await getTeam(token, controller.team, 'pico')
            teamName = team.name
        }
        this.setState({controller, teamName})
    }

    handleCommandWebSocketResponse(data) {
        let command = Command.fromAPIObject(JSON.parse(data))
        let otherCommands = this.state.waitingOnCommands.filter((c) => c.id !== command.id)
        let failed = 2
        let sent = 1
        if (command.status === sent) {
            let stillLoading = true
            let sendCommandButtonText = "Sending..."
            if (!otherCommands.length) {
                stillLoading = false
                sendCommandButtonText = "Command Sent!"
            }
            this.setState({waitingOnCommands: otherCommands, sendCommandLoading: stillLoading, sendCommandButtonText})
            if (!stillLoading) {
                setTimeout(() => {
                    this.setState({sendCommandButtonText: "Send Command"})
                }, 3000)
            }
        } else if (command.status === failed) {
            let errorMsg = "An unknown error occurred. Please try again in a few minutes."
            if (command.response && command.response.error) {
                errorMsg = command.response.error
            } else if (command.response) {
                errorMsg = command.response
            }
            let appError = new AppError("Controller Rejected Command", errorMsg)
            this.setState({errors: [appError], sendCommandLoading: false, sendCommandButtonText: "Send Command"})
        }
    }

    handleChangeSettingsButtonClick(e = null) {
        if (e) {
            e.preventDefault()
        }
        let commandPanelVisible = !this.state.commandPanelVisible
        this.setState({commandPanelVisible})
    }

    async handleSendCommandButtonClick(e) {
        e.preventDefault()
        let {token} = this.state
        if (this.state.sendCommandLoading || this.state.waitingOnCommands.length) {
            return
        }

        let command = new Command()
        command.controller = this.state.controllerID
        command.rate = this.state.rate
        command.units = this.state.units
        command.batchEnable = (this.state.batchEnable !== this.state.controller.latestExtendedDataPoint.batch_control ? this.state.batchEnable : null)
        command.batchTotalReset = this.state.resetBatchTotal
        command.setpoint = this.state.setpoint
        command.scheduledStartMode = (this.state.scheduledStart === false ? 0 : (this.state.scheduledStart ? (this.state.repeatStart ? 2 : 1) : null))
        command.scheduledStartTime = this.state.startTime
        command.scheduledStopMode = (this.state.scheduledStop === false ? 0 : (this.state.scheduledStop ? (this.state.repeatStop ? 2 : 1) : null))
        command.scheduledStopTime = this.state.stopTime
        command.waterTotalReset = this.state.resetWaterTotal
        command.userTotalReset = this.state.resetControllerTotal
        command.remoteStartStopSetting = (this.state.toggleRunning ? (this.state.controller.running ? 1 : 2) : null)

        let commands = command.splitByCommandGroup()
        this.setState({sendCommandLoading: true, sendCommandButtonText: "Sending..."})

        let waitingOnCommands = []
        for (let i = 0; i < commands.length; i++) {
            let c = commands[i]
            try {
                let response = await sendCommand(token, c)
                waitingOnCommands.push(response)
            } catch (error) {
                let appError = new AppError("Failed to Send Command", error)
                this.setState({
                    errors: [appError],
                    sendCommandLoading: false,
                    waitingOnCommands: [],
                    sendCommandButtonText: "Send Command"
                })
            }
        }
        this.setState({waitingOnCommands, sendCommandButtonText: "Waiting for Controller Response..."})
    }

    async handleRefreshButtonClick(e = null) {
        let {token} = this.state
        if (e) {
            e.preventDefault()
        }
        this.setState({requestDataLoading: true, requestButtonText: "Sending Request..."})

        try {
            let command = new Command()
            command.controller = this.state.controllerID
            command.requestDataUpdate = true
            let response = await sendCommand(token, command)
        } catch (error) {
            let appError = new AppError("Failed to send request", error.message)
            this.setState({errors: [appError]})
        }

        this.setState({requestDataLoading: false, requestButtonText: "Request Sent!"})
        setTimeout(() => {
            this.setState({requestButtonText: "Request New Data"})
        }, 3000)
    }

    handleCommandFormInputChange(e) {
        if (e.preventDefault) {
            e.preventDefault()
        }
        let val = e.target.value
        let name = e.target.name
        if (e.target.type === "checkbox") {
            val = e.target.checked
        }
        this.setState({[name]: val})
    }

    async downloadLogFile(e) {
        e.preventDefault()
        let {token} = this.state
        // get log file with start and end dates from api
        this.setState({loadingLog: true})
        let logFile = await getStatusLogForController(token, this.state.controller.id, this.state.startDate, this.state.endDate)

        let logFileName = `${this.state.controller.userIdentifiableName.replace(' ', '_').replace('.', '_')}`
        if (this.state.startDate) {
            let day = this.state.startDate.getDate()
            if (String(day).length < 2) {
                day = `0${day}`
            }
            let month = this.state.startDate.getMonth() + 1
            if (String(month).length < 2) {
                month = `0${month}`
            }
            let year = this.state.startDate.getYear() + 1900
            logFileName += `_from_${year}-${month}-${day}`
        }
        if (this.state.endDate) {
            let day = this.state.endDate.getDate()
            if (String(day).length < 2) {
                day = `0${day}`
            }
            let month = this.state.endDate.getMonth() + 1
            if (String(month).length < 2) {
                month = `0${month}`
            }
            let year = this.state.endDate.getYear() + 1900
            logFileName += `_to_${year}-${month}-${day}`
        }
        logFileName += '.csv'

        let element = document.getElementById('mobile-log-link')
        let blob = new Blob([logFile], {type: 'application/msexcel'})
        let URL = window.URL || window.webkitURL
        element.setAttribute('href', URL.createObjectURL(blob))
        element.setAttribute('download', logFileName)

        if (pageHelpers.userOnMobileDevice()) {
            this.setState({mobileLogLinkVisible: true})
        } else {
            element.click()
        }

        this.setState({loadingLog: false})
    }


    async handleRenewSubscriptionClick(e = null) {
        this.setState({
            loading: true,
            choosePaymentModal: true
        })

        try {
            let {controller, token,} = this.state
            let controllerID = controller.id
            let renewResponse = await subscriptionHelpers.renewSubsPlan(token, controllerID)
            if (!renewResponse.error) {
                let appError = new AppError(SUCCESS, SUBS_PLAN_RENEW_SUCCESS)
                await this.setState({ errors: [appError], loading: true, modal: false })
                await this.fetchController()
                await this.fetchFields()
                await this.getSubscriptionData(token, controllerID)
                await this.setState({ loading: false})
            } else {
                this.setState({ errors: [renewResponse.error] })
            }
        } catch (error) {
            let appError = new AppError("Failed to send request", error.message)
            this.setState({ errors: [appError] })
        }
    }

    async getSubscriptionData(token, teamId, controllerId) {
	try {
         
        let discountData = await getTeamDiscount(token, teamId)
	    let discountAmount = (discountData.discount.discount/100)
	    this.setState({discountAmount})
        } catch (error) {
            console.log(error)
        }
        try {
            let subscriptionData = await subscriptionHelpers.getMySubscriptionPlan(token, controllerId)
            if (!subscriptionData.error) {
                let subsPlanID = subscriptionData.subscription_plan
                let date = new Date();
                var currentYear = date.getFullYear();
                await this.getSubscriptionPrice(token, subsPlanID, currentYear)
                this.setState({
                    is_subscription_expired: subscriptionData.is_expired,
                    is_subscription_trial: subscriptionData.is_trial,
                    is_subscription_paid: subscriptionData.is_paid,
                    no_subscription: false,
                    choosePaymentModal: false,
                    subsRemainingDays: subscriptionData.remaining_days,
                   
                })

                let defaultPlanData = await subscriptionHelpers.getDefaultSubsPlan(token)
                let defaultPlan = defaultPlanData[0].subscriptionPlan
                let defaultPriceData = defaultPlan.SubscriptionPlanPrice_set[0]
                let defaultPlanPrice = defaultPriceData.subscription_price
                this.setState({defaultPlanPrice,isSeasoned:defaultPlan.is_seasoned})
            } else {
                this.setState({no_subscription:true})

                let defaultPlanData = await subscriptionHelpers.getDefaultSubsPlan(token)
                let defaultPlan = defaultPlanData[0].subscriptionPlan
                let defaultPriceData = defaultPlan.SubscriptionPlanPrice_set[0]
                let defaultPlanPrice = defaultPriceData.subscription_price
                this.setState({defaultPlanPrice})
            }
        } catch (error) {
            console.log(error)
        }
    }

    async getSubscriptionPrice(token, subsPlanID, subsPlanYear) {
        try {
            let subscriptionPriceData = await subscriptionHelpers.getSubscriptionPlanPrice(token, subsPlanID, subsPlanYear)
            if (!subscriptionPriceData.error) {
                this.setState({ endsubscription:subscriptionPriceData[0].subscription_year,subscriptionPlanPrice: subscriptionPriceData[0].subscription_price })
            } else {
                console.log("failed to get price data")
                console.log(subscriptionPriceData.error)
                //this.setState({errors:[subscriptionData.error]})
            }
        } catch (error) {
            console.log(error)
        }
    }

    toggle() {
        this.setState({
            modal: !this.state.modal,
            renewSubsBySupport: true,
        });
    }

    selectPayment() {
        console.log("TOGGLE SELECT PAYMENT")
        this.setState({
            choosePaymentModal: !this.state.choosePaymentModal
        })
    }

    render() {
        let controller = this.state.controller || new Controller()
        let currentdate=new Date();
        let subsEndDate = this.state.endsubscription
        let {
            errors, loading, requestButtonText, modem_model, requestDataLoading, teamName, fields, activeTab, user, controllerID,
            token, mobileLogLinkVisible, loadingLog, choosePaymentModal, subscriptionPlanPrice, modal,
            renewSubsBySupport, is_subscription_expired, is_subscription_trial, is_subscription_paid, no_subscription, defaultPlanPrice,
	    discountAmount, subsRemainingDays,isSeasoned
        } = this.state
        return (<div>
            {/***** Open modal to select payment method  *****/}
            {controller && renewSubsBySupport ?
                <ui.RenewSubsModal controllerid={controller.id}
                                     renewSubscriptionPlan={this.handleRenewSubscriptionClick}
                                     modal={modal}
                                     toggle={this.toggle} />:
                controller ?
                <div>
                    <ui.SelectPaymentMethod isOpen={choosePaymentModal}
                                               backdrop='static'
                                               toggle={this.selectPayment}
                                               className={this.props.className}
                                               invoice={no_subscription ? "yes":"no"}
                                               controllerid={controller.id}
                                               renewSubscriptionPlan={this.handleRenewSubscriptionClick}
                                               amount={(defaultPlanPrice*(1-discountAmount))} />
                </div>:
                null}

            {user && controller ?
                <ui.ControllerNavigationTabs user={user}
                                             archived={controller.archived}
                                             controllerTeam={controller.team}
                                             activeTab={activeTab}
                                             onTabClick={this.switchTab}
                                             is_trial={is_subscription_trial}
                                             currentdate={currentdate.getFullYear()}
                                             subsEndDate={subsEndDate}
                                             is_subscription_paid={is_subscription_paid}
                                             subsRemainingDays={subsRemainingDays}/> :
                null}

            <Col xs={12}
                 className="bg-light large-rounded border-light-sf-orange justify-content-center p-0">
                {!loading && user && controller ?
                    <ui.ControllerTabHeader user={user}
                                            modem_model={modem_model}
                                            controller={controller}
                                            field={controller.field}
                                            teamName={teamName}
                                            isSeasoned={isSeasoned}
                                            currentdate={currentdate.getFullYear()}
                                            subsEndDate={subsEndDate}
                                            requestDataLoading={requestDataLoading}
                                            onRequestDataButtonClick={this.handleRefreshButtonClick}
                                            no_subscription={no_subscription}
                                            is_expired={is_subscription_expired}
                                            is_trial={is_subscription_trial}
                                            is_paid={is_subscription_paid}
                                            selectPayment={() => this.selectPayment()}
                                            toggle={() => this.toggle()}
                                            requestButtonText={requestButtonText}/> :
                    null}
                    {/* Added a condition on basis of checking 
                    if plan is paid and remaininig days equal to zero
                    then dashboard data will not be accessible
                     */}
                {loading ? <div className="mt-5 mb-5 col-12 text-center">
                        <Loader type="TailSpin" color="orange" width={60} height={60}/>
                    </div> :
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="1">
                            <Col xs={12} className="p-0 m-0">
                            {is_subscription_trial && subsRemainingDays === 0? null:
                            is_subscription_paid && currentdate.getFullYear() >subsEndDate?null:
                                <div className="align-items-start col-12 p-0 m-0 bg-light border">
                                    <ui.ControllerAlarmPanel controller={controller}/>
                                    <ui.ControllerGaugeCluster controller={controller}/>
                                    <div className="col-12 pl-0 pr-0 border-top border-bottom bg-light-sf-orange">
                                        {(controllerID && controller ?
                                            <ui.ControllerMap controllers={[controller]}
                                                              centerOnController={true}
                                                              onControllerMouseOver={(e) => (void(0))}
                                                              onControllerMouseOut={(e) => (void(0))}
                                                              onControllerClick={(e) => void(0)}/> :
                                            null)}
                                    </div>
                                    <ui.ControllerLastUpdatedPanel controller={controller}/>
                                </div>
                            }
                            </Col>
                        </TabPane>
                        <TabPane tabId="2">
                            <Col xs={12} className="p-0 m-0">
                                {loading ? <div className="mt-5 mb-5 col-12 text-center">
                                        <Loader type="TailSpin" color="orange" width={60} height={60}/>
                                    </div> : is_subscription_trial && subsRemainingDays === 0? null:is_subscription_paid&& currentdate.getFullYear() >subsEndDate ?null:
                                    <div className="align-items-start col-12 p-0 m-0 bg-light border">
                                        <ui.ControllerSettingsPanel controller={controller}
                                                                    fields={fields}
                                                                    token={token}
                                                                    user={user}/>
                                    </div>}
                            </Col>
                        </TabPane>
                        <TabPane tabId="3">
                            <Col xs={12} className="p-0 m-0">
                                {loading ? <div className="mt-5 mb-5 col-12 text-center">
                                        <Loader type="TailSpin" color="orange" width={60} height={60}/>
                                    </div> :
                                    
                                    <div className="align-items-start col-12 p-0 m-0 bg-light border">
                                        {user && user.isDealer && `${controller.team}` !== `${user.activeTeam}` ?
                                            <ui.InfoAlert header="Historical Data Limited"
                                                          body="Dealers can only view the past two weeks of customer data."
                                                          alertKey="dealer_historical_data_limited"/> :
                                            null}
                                        <ui.ControllerTrendsPanel controller={controller}
                                                                  controllerID={controllerID}
                                                                  user={user}
                                                                  token={token}/>
                                    </div>}
                            </Col>
                        </TabPane>
                        <TabPane tabId="4">
                            <Col xs={12} className="p-0 m-0">
                                {loading ? <div className="mt-5 mb-5 col-12 text-center">
                                        <Loader type="TailSpin" color="orange" width={60} height={60}/>
                                    </div> :
                                    
                                    <div className="align-items-start col-12 p-0 m-0 bg-light border">
                                        {user && user.isDealer && `${controller.team}` !== `${user.activeTeam}` ?
                                            <ui.InfoAlert header="Historical Data Limited"
                                                          body="Dealers can only view the past two weeks of customer data."
                                                          alertKey="dealer_historical_data_limited"/> :
                                            null}
                                        <ui.ControllerLogsForm loading={loadingLog}
                                                                  defaultStart={(new Date())}
                                                                  defaultEnd={(new Date())}
                                                                  onStartDateChange={startDate => {
                                                                       //The ISO string coming from the calendar selection uses '-' as a delimiter and puts the date a day behind
                                                                      startDate = new Date(startDate.toISOString().replace(/-/g, '\/').replace(/T.+/, ''));
                                                                      this.setState({
                                                                          startDate,
                                                                          mobileLogLinkVisible: false
                                                                      });
                                                                      this.state.startDate=startDate;
                                                                    }
                                                                  }
                                                                  onEndDateChange={endDate => {
                                                                      //The ISO string coming from the calendar selection uses '-' as a delimiter and puts the date a day behind
                                                                      endDate = new Date(endDate.toISOString().replace(/-/g, '\/').replace(/T.+/, ''));
                                                                      this.setState({
                                                                          endDate,
                                                                          mobileLogLinkVisible: false
                                                                      });
                                                                      this.state.endDate=endDate;
                                                                    }
                                                                  }
                                                                  onSubmit={this.downloadLogFile}/>

                                        <a id="mobile-log-link"
                                           className={`m-2 ${mobileLogLinkVisible ? "" : "invisible"}`} href="">
                                            Tap Here to Download Log.
                                        </a>
                                    </div>}
                            </Col>
                        </TabPane>
                        <TabPane tabId="5">
                            <Col xs={12} className="p-0 m-0">
                                {loading ? <div className="mt-5 mb-5 col-12 text-center">
                                        <Loader type="TailSpin" color="orange" width={60} height={60}/>
                                    </div> :
                                    
                                    <div className="align-items-start col-12 p-0 m-0 bg-light border">
                                        <ui.ControllerAboutPanel controller={controller}/>
                                    </div>}
                            </Col>
                        </TabPane>
                        {controller && !controller.archived ?
				<TabPane tabId="6">
				    <div className="p-0 m-0">
					{loading && token ? <div className="mt-5 mb-5 col-12 text-center">
						<Loader type="TailSpin" color="orange" width={60} height={60}/>
					    </div> :
					    <div className="align-items-start container bg-light border">
						<ui.ControllerSubscriptionPanel controller={controller} is_subscription_trial={is_subscription_trial} token={token} history={this.history} match={this.props.match}/>
					    </div>}
				    </div>
				</TabPane>: null}
                    </TabContent>}
            </Col>
            {controller && controller.id && user && user.isSupport ?
                <ui.AdminLinkBubble url={`marksman_api/controller/${controller.id}`}
                                    modelName="Controller"
                                    className="mt-2"/> :
                null}

            {pageHelpers.renderErrorModalsForPage(errors, this)}
            {(controllerID && token && token.accessToken ?
                <Websocket url={`${WS_URL}/controllers/${controllerID}/?access_token=${token.accessToken}`}
                           onMessage={this.handleControllerWebSocketResponse}/> : null)}
        </div>)
    }
}

export default withRouter(ControllerDashboard)




// WEBPACK FOOTER //
// ./src/components/pages/controllers/ViewPage.js